// this file defines reducers specific for listing page
import { combineReducers } from 'redux';

import listingPageCommonData from './listingPageCommonData.reduck';
import listingPageComparison from './listingPageComparison.reduck';
import listingPageComparePopup from './listingPageComparePopup.reduck';
import listingPageFirstRenderOnClient from './listingPageFirstRenderOnClient.reduck';
import listingPagePages from './listingPagePages.reduck';
import listingPageLocationSearchSetup from './listingPageLocationSearchSetup.reduck';
import listingPageBrowser from './listingPageBrowser.reduck';
import listingPageStaticData from './listingPageStaticData.reduck';


export default combineReducers({
  // contains static data configuration, translation, etc. from UBO (Universal Backend Service)
  staticData: listingPageStaticData,

  // contains data for Compare Panel and Compare Checkboxes
  comparison: listingPageComparison,

  // contains data for Compare Popup
  comparePopup: listingPageComparePopup,

  // contains statuses when loading data for first render on client
  firstRenderOnClient: listingPageFirstRenderOnClient,

  // contains data for listing page pages which user visited, they're used as a cache
  pages: listingPagePages,

  // contains common data required for the whole listing page
  commonData: listingPageCommonData,

  // contains data for location search which is used in Location Search Panel
  locationSearchSetup: listingPageLocationSearchSetup,

  // contains data about user's browser
  browser: listingPageBrowser
});
